export const TRANSLATED_ROUTE_TYPES = {
    product: {
        en: "product"
        // de: "produkt",
        // fr: "produit",
        // ja: "商品"
    },
    categories: {
        en: "categories"
        // de: "kategorien",
        // fr: "catégories",
        // ja: "カテゴリー"
    },
    journal: {
        en: "journal"
        // de: "journal",
        // fr: "journal",
        // ja: "ジャーナル"
    },
    pressroom: {
        en: "pressroom"
        // de: "presse",
        // fr: "presse",
        // ja: "プレスルーム"
    },
    cart: {
        en: "cart"
        // de: "warenkorb",
        // fr: "panier",
        // ja: "カート"
    },
    checkout: {
        en: "checkout"
        // de: "kasse",
        // fr: "paiement",
        // ja: "チェックアウト"
    }
}

export const TRANSLATED_ROUTE_SEGMENTS = {
    categories: {
        en: `/${TRANSLATED_ROUTE_TYPES.categories.en}`,
        de: `/${TRANSLATED_ROUTE_TYPES.categories.en}`,
        fr: `/${TRANSLATED_ROUTE_TYPES.categories.en}`,
        ja: `/${TRANSLATED_ROUTE_TYPES.categories.en}`
    },
    categoriesWithSlug: {
        en: `/${TRANSLATED_ROUTE_TYPES.categories.en}/[...slug]`,
        de: `/${TRANSLATED_ROUTE_TYPES.categories.en}/[...slug]`,
        fr: `/${TRANSLATED_ROUTE_TYPES.categories.en}/[...slug]`,
        ja: `/${TRANSLATED_ROUTE_TYPES.categories.en}/[...slug]`
    },
    product: {
        en: `/${TRANSLATED_ROUTE_TYPES.product.en}/[...slug]`,
        de: `/${TRANSLATED_ROUTE_TYPES.product.en}/[...slug]`,
        fr: `/${TRANSLATED_ROUTE_TYPES.product.en}/[...slug]`,
        ja: `/${TRANSLATED_ROUTE_TYPES.product.en}/[...slug]`
    },
    journal: {
        en: `/${TRANSLATED_ROUTE_TYPES.journal.en}`,
        de: `/${TRANSLATED_ROUTE_TYPES.journal.en}`,
        fr: `/${TRANSLATED_ROUTE_TYPES.journal.en}`,
        ja: `/${TRANSLATED_ROUTE_TYPES.journal.en}`
    },
    journalWithSlug: {
        en: `/${TRANSLATED_ROUTE_TYPES.journal.en}/[...slug]`,
        de: `/${TRANSLATED_ROUTE_TYPES.journal.en}/[...slug]`,
        fr: `/${TRANSLATED_ROUTE_TYPES.journal.en}/[...slug]`,
        ja: `/${TRANSLATED_ROUTE_TYPES.journal.en}/[...slug]`
    },
    checkout: {
        en: `/${TRANSLATED_ROUTE_TYPES.checkout.en}`,
        de: `/${TRANSLATED_ROUTE_TYPES.checkout.en}`,
        fr: `/${TRANSLATED_ROUTE_TYPES.checkout.en}`,
        ja: `/${TRANSLATED_ROUTE_TYPES.checkout.en}`
    },
    pressroom: {
        en: `/${TRANSLATED_ROUTE_TYPES.pressroom.en}`,
        de: `/${TRANSLATED_ROUTE_TYPES.pressroom.en}`,
        fr: `/${TRANSLATED_ROUTE_TYPES.pressroom.en}`,
        ja: `/${TRANSLATED_ROUTE_TYPES.pressroom.en}`
    },
    pressroomWithSlug: {
        en: `/${TRANSLATED_ROUTE_TYPES.pressroom.en}/[...slug]`,
        de: `/${TRANSLATED_ROUTE_TYPES.pressroom.en}/[...slug]`,
        fr: `/${TRANSLATED_ROUTE_TYPES.pressroom.en}/[...slug]`,
        ja: `/${TRANSLATED_ROUTE_TYPES.pressroom.en}/[...slug]`
    }
} as const
